// extracted by mini-css-extract-plugin
export default {"container":"GLE18","icon":"LOwh2","text":"ZXFYX"};